import { ICurrencyEntityReference, IPhotoEntityReference } from 'libs/shared/src/models/basic';

export interface IStandardItem<ItemType = string, NestedItemType = undefined> {
  type: ItemType;
  nestedType: NestedItemType;
  nestedID: number;
  ownerMemberID?: number;
  title?: string;
  subTitle?: string;
  text?: string;
  text2?: string;
  /** Phone number */
  phone?: string;
  detailLink?: string;
  priceInfo?: IUsePrice;
  photo?: IPhotoEntityReference;
  index?: number;
  iD: number;
  dateTime?: string;
  validTo?: string;
  validFrom?: string;
  color?: string;
  teaser?: string;
  teaserColor?: string;
  currency?: ICurrencyEntityReference;
  available?: boolean;
}

export interface IStandardCRUDItem<ItemType = string, NestedItemType = undefined> extends IStandardItem<ItemType, NestedItemType> {
  canUpdate?: boolean;
  canDelete?: boolean;
  canView?: boolean;
  canOpen?: boolean;
}

export interface IHierachicalStandardItem extends IStandardItem {
  hasChildren?: boolean;
}

export interface IUsePrice {
  currency?: ICurrency;
  minKeyPrice?: IAmount;
  minKeyOldPrice?: IAmount;
  priceCount?: number;
  info?: string;
  countKeyPrices?: number;
  countKeyOldPrices?: number;
}

export interface IArticleKeyPrice {
  articleKeyPriceID?: number;
  currency?: ICurrency;
  price?: number;
  priceMarket?: number;
  priceMarketShipping?: number;
  priceNet?: boolean;
  priceOld?: number;
  pricePurchase?: number;
  priceShipping?: number;
  priceUVP?: number;
  priceUnitAmount?: number;
  quantity?: number;
  taxIncluded?: boolean;
  type?: PriceListPriceType;
  valueUnitType?: PriceUnitType;
}

/** Preislistentypen */
export enum PriceListPriceType {
  /** Verpackungseinheit / VE */
  PU = 1,
  /** Lage */
  Tray = 2,
  /** Voll / Komplettpreis */
  Full = 3,
  /** Frei */
  Free = 4,
  /** Stück / Stk. / Pcs */
  Piece = 5
}

/** Einheitstypen für Preiseinheiten */
export enum PriceUnitType {
  /** Stück / Stk. / Pcs */
  Pcs = 0,
  /** Liter / l */
  Liter = 1,
  /** Meter / m */
  Meter = 2,
  /** Quadratmeter / m² */
  SquareMeter = 3,
  /** Kilogramm / kg */
  Kg = 4,
  /** VE = Verpackungseinheit / ve */
  PackingUnit = 5,
  /** Zentimeter / cm */
  Cm = 6,
  /** Gramm / g */
  G = 7,
  /** Millimeter / mm */
  Mm = 8,
  /** Milliliter / ml */
  Ml = 9,
  /** Paket / pk. */
  Pk = 10,
  /** Tafel */
  Plate = 11,
  /** Kubikmeter / m³ */
  CubicMeter = 12,
  /** Bündel */
  Bunch = 13,
  /** Lage */
  Tray = 14,
  /** Karre / LT */
  Cc = 15,
  /** Korn */
  Grain = 16,
  /** Pille */
  Pill = 17,
  /** Sack */
  Sack = 18
}

export interface ICurrency {
  minKeyPrice?: IAmount;
  iD: number;
  name?: string;
  factor?: number;
  nameShort: string;
  sign: string;
}

export interface IAmount {
  currency?: ICurrency;
  value?: number;
  roundedValue?: number;
  euroValue?: number;
}
